import { show_layout_modal } from "./global";
import Editor from '@toast-ui/editor';

class AccountsAnnouncementsPage {
  static MIN_NUM_WORDS = 140;
  static MAX_NUM_WORDS = 400;

  init() {
    if ($('#announce-data').length === 0) {
      return;
    }

    var show_or_edit = $('#announce-data').data('show-or-edit');
    if (show_or_edit === 'show') {
      this.display_show();
    } else {
      this.display_edit();
    }

    this.update_num_words();
  }

  write_num_words(num_words) {
    $('#num-words').html(`${num_words} words`);
    if (num_words >= AccountsAnnouncementsPage.MAX_NUM_WORDS - 10) {
      $('#num-words').html(`<span style='color: red'>${num_words} words</span>`);
    }
    else if (num_words < AccountsAnnouncementsPage.MIN_NUM_WORDS) {
      $('#num-words').html(`<span style='color: orange'>${num_words} words</span>`);
    }
  }

  setup_enable_save_button() {
    $('#announce-draft-body').on('keyup', (event) => {
      this.enable_disable_save_button();
    });

    $('#announce-draft-title').on('keyup', (event) => {
      this.enable_disable_save_button();
    });
  }

  enable_disable_save_button() {
    if ($('#announce-data').data('is-admin-user') === true) {
      $('#save-announce').prop('disabled', false);
      return;
    }
    $('#save-announce').prop('disabled', !this.is_announcement_present());
  }

  is_announcement_present() {
    return ($('#announce-draft-title').val().length > 0 && this.texteditor_body().length > 0)
  }

  setup_num_words_tracker() {
    $('#announce-draft-body').on('keydown', (event) => {
      if ($('#announce-data').data('is-admin-user') === true) {
        return;
      }

      var announce_text = this.texteditor_body();
      var num_words = announce_text.trim().split(/\s+/).length;
      if (event.which < 0x20 || event.which==65 || event.which==88) {
        return;
      }
      if (num_words > AccountsAnnouncementsPage.MAX_NUM_WORDS) {
        event.preventDefault();
      }
    });

    $('#announce-draft-body').on('keyup', () => {
      this.update_num_words();
    });

    $('#announce-draft-body').on('paste', () => {
      this.update_num_words();
    });
  }

  update_num_words() {
    var announce_text = this.texteditor_body();
    var arr = announce_text.trim().split(/\s+/);
    var num_words = arr.length;
    if (arr.length === 1 && arr[0] === "") {
      num_words = 0;
    }
    this.write_num_words(num_words);
  }

  setup_save_announce_click() {
    $('#save-announce').on('click', () => {
      var ann_id = this.announce_id();
      var title = $('#announce-draft-title').val();
      var body = this.texteditor_body();
      var hoster_id = $('#hoster-id').val();

      var method = "POST";
      var url = "/accounts/announcements";
      if (ann_id > 0) {
        method = "PUT";
        url = url + "/" + ann_id;
      }

      $.ajax({ method: method,
               url: url,
               data: { title: title, body: body, hoster_id: hoster_id },
               dataType: 'json',
               success: (response) => {
                 console.log("save success");
                 this.set_flash("Your announcement was successfully updated.");

                 var ann_id = response.announcement.id;
                 $('#announce-data').data('announce-id', ann_id);
                 $('#announce-show-title').html(title);
                 $('#announce-state').html(response.announcement.new_state);
                 $('#announce-hoster-name').html(response.announcement.hoster_name);
                 if (response.announcement.new_state === "Draft") {
                   $('#request-publish-announce').removeClass('d-none');
                 }
                 this.refresh_markdown_body();
                 this.display_show();
                 window.history.pushState({}, 'ignored', `/accounts/announcements/${ann_id}`);
                },
               error: (resp, textStatus, xhr) => {
                 console.log(`save failure - code=${resp.status}`);
                 var respBody = resp.responseJSON;
                 if (respBody !== undefined) {
                   show_layout_modal(`Failed to update announce: ${respBody.error}.`);
                 } else {
                   show_layout_modal(`Server error.`);
                 }
               }
      });
    });
  }

  setup_cancel_edit_announce_click() {
    $('#cancel-edit-announce').on('click', () => {
      var ann_id = this.announce_id();
      if (ann_id !== 0) {
        window.history.pushState({}, 'ignored', `/accounts/announcements/${ann_id}`);
        this.display_show();
      } else {
        Turbo.visit("/accounts/announcements");
      }
    })
  }


  refresh_markdown_body() {
    $.ajax({
      url: `/accounts/announcements/${this.announce_id()}/markdown_body`,
      method: 'GET',
      dataType: 'json',
      success: (resp) => {
        console.log("markdown body get success");
        $('#announce-show-body').html(resp.html);
        $('#announce-draft-body').data('body', resp.markdown);
        this.bodyeditor = this.new_texteditor(resp.markdown);
      },
      error: () => {
        var err = "Markdown body get request failed";
        show_layout_modal(err);
        console.log(err);
      }
    });
  }

  setup_request_publish_click() {
    $('#request-publish-announce').on('click', () => {
      this.put_request_to_publish(this.announce_id());
    });
    $('.request-publish-button').on('click', (e) => {
      var row = $(e.currentTarget).parents('tr').first();
      var announce_id = row.data('announce-id');
      this.put_request_to_publish(announce_id);
    });
  }

  put_request_to_publish(announce_id) {
    $.ajax({ method: "PUT",
      url: `/accounts/announcements/${announce_id}/request_to_publish`,
      dataType: 'json',
      success: (resp, textStatus, xhr) => {
        var msg = "Your request to publish has been submitted.";
        if (resp.message !== undefined) {
          msg = resp.message;
        }
        console.log(`request to publish success - ${textStatus} - ${xhr.status}`);
        show_layout_modal(msg, undefined, true);
      },
      error: (resp, textStatus, xhr) => {
        console.log(`publish failure - code=${resp.status}`);
        var respBody = resp.responseJSON;
        show_layout_modal(`Failed to publish announcement: ${respBody.error}.`);
      }
    });
  }

  setup_edit_announce_click() {
    $('#edit-announce').on('click', () => {
      var ann_id = this.announce_id();
      window.history.pushState({}, 'ignored', `/accounts/announcements/${ann_id}/edit`);
      this.display_edit();
    });
  }

  setup_delete_row_buttons_click() {
    $('table#announcements-table').on('click', '.delete-button', (event) => {
      event.preventDefault();
      if (!confirm("Are you sure?")) {
        return;
      }

      var row = $(event.currentTarget).parents('tr').first();
      var announce_id = $(row).data('announce-id');
      console.log(`delete click for ann id ${announce_id}`);
      $.ajax({ method: "DELETE",
               url: `/accounts/announcements/${announce_id}`,
               dataType: 'json',
               success: (resp, textStatus, xhr) => {
                 console.log(`delete success - ${textStatus} - ${xhr.status}`);
                 this.set_flash("Your announcement was successfully deleted.");
                 row.fadeOut(1000);
               },
               error: (resp, textStatus, xhr) => {
                 console.log(`delete failure - code=${resp.status}`);
                 var respBody = resp.responseJSON;
                 show_layout_modal(`Failed to delete announcement: ${respBody.error}.`);
               }
      });

    });
  }

  setup_delete_edit_button() {
    $('#announce-show').on('click', 'a#delete-announce', (event) => {
      event.preventDefault();
      if (!confirm("Are you sure?")) {
        return;
      }

      console.log(`delete click for ann id ${this.announce_id()}`);
      $.ajax({ method: "DELETE",
               url: `/accounts/announcements/${this.announce_id()}`,
               dataType: 'json',
            success: (resp, textStatus, xhr) => {
              console.log(`delete success - ${textStatus} - ${xhr.status}`);
              Turbo.visit('/accounts/announcements');
              this.set_flash("Your announcement was successfully deleted.");
            },
            error: (resp, textStatus, xhr) => {
              console.log(`delete failure - code=${resp.status}`);
              var respBody = resp.responseJSON;
              show_layout_modal(`Failed to delete announcement: ${respBody.error}.`);
            }
      });

    });
  }

  setup_publish_buttons_click() {
    $('table#announcements-table').on('click', '.publish-button', (event) => {
      event.preventDefault();
      this.show_publish_modal(event.currentTarget);
    });
  }

  show_publish_modal(publish_button) {
    $('#publish-modal').on('shown.bs.modal', () => {
      $('#publish-modal-close').trigger('focus');
    });
    $('#publish-modal').modal({});

    $('#publish-modal-publish').on('click', () => {
      var row = $(publish_button).parents('tr').first();
      this.publish_announcement(row, true);
    });
    $('#publish-modal-decline').on('click', () => {
      var row = $(publish_button).parents('tr').first();
      this.publish_announcement(row, false, $('#decline-reason').val());
    });
  }

  publish_announcement(row, approve, decline_reason) {
    var announce_id = $(row).data('announce-id');
    console.log(`publish click for ann id ${announce_id}`);
    $.ajax({ method: "PUT",
             url: `/accounts/announcements/${announce_id}/publish`,
             contentType: "application/json",
             data: JSON.stringify({ approve: approve, decline_reason: decline_reason }),
             dataType: 'json',
        success: (resp, textStatus, xhr) => {
          console.log(`publish review success - ${textStatus} - ${xhr.status}`);
          this.set_flash(`Announcement id ${announce_id} was reviewed: new state = ${resp.new_state}.`);
          $(row).find('.announcement-state').html(resp.new_state);
          $('#publish-modal').modal('hide');
          $(row).find('#publish-announce').addClass('d-none');
        },
        error: (resp, textStatus, xhr) => {
          console.log(`publish failure - code=${resp.status}`);
          var respBody = resp.responseJSON;
          show_layout_modal(`Failed to publish announcement: ${respBody.error}`);
          $('#publish-modal').modal('hide');
        }
    });
  }

  reset_publish_modal() {
    $('#publish-modal #decline-reason').val('');
  }

  announce_id() {
    var id = $('#announce-data').data('announce-id');
    return id;
  }

  display_edit() {
    $('#announce-show').addClass("d-none");
    $('#announce-edit').removeClass("d-none");
    this.enable_disable_save_button();
  }

  display_show() {
    $('#announce-edit').addClass("d-none");
    $('#announce-show').removeClass("d-none");
  }

  texteditor() {
    if (this.bodyeditor !== undefined) {
      return this.bodyeditor;
    }

    if ($('#announce-draft-body').length == 0) {
      return undefined;
    }

    this.bodyeditor = this.new_texteditor(this.body_markdown());

    return this.bodyeditor;
  }

  new_texteditor(markdown) {
    console.log(`Creating new Editor`);
    return new Editor({
      el: document.querySelector('#announce-draft-body'),
      height: '600px',
      initialEditType: 'wysiwyg',
      previewStyle: 'tab',
      initialValue: markdown,
      usageStatistics: false,
      toolbarItems: [
        ['heading', 'bold', 'italic'],
        ['ul', 'ol', 'indent', 'outdent'],
        ['table', 'link'],
        ['hr', 'quote', 'codeblock'] ],
    });
  }

  texteditor_body() {
    if (this.texteditor() === undefined) {
      console.log(`this.texteditor is undefined`);
      return "";
    }
    return this.texteditor().getMarkdown();
  }

  body_markdown() {
    var escaped = $('#announce-draft-body').data('body');
    return escaped.replace("&quot;", '"').replace("&#039;", "'");
  }

  set_flash(msg) {
    var elt = "#flash-js";
    $(elt).html(msg);
    $(elt).removeClass("d-none");
    $(elt).slideDown();
    setTimeout( () => {
      $(elt).slideUp(400, () => { $(elt).addClass("d-none") });
    }, 5000);
  }

}

$(document).on('turbo:load', function() {
  if ($("body.accounts_announcements").length == 0) {
    return;
  }
  console.log("page load in accounts_announcements.js");


  var announcePage = new AccountsAnnouncementsPage();
  announcePage.init();
  announcePage.setup_save_announce_click();
  announcePage.setup_cancel_edit_announce_click();
  announcePage.setup_edit_announce_click();
  announcePage.setup_num_words_tracker();
  announcePage.setup_request_publish_click();
  announcePage.setup_delete_row_buttons_click();
  announcePage.setup_delete_edit_button();
  announcePage.setup_publish_buttons_click();
  announcePage.setup_enable_save_button();

  if ($("body.accounts_announcements.new_snippet").length > 0) {
    setup_snippet_form_submit();
  }
});


export function setup_snippet_form_submit() {
  console.log("Setting up snippet form submit handler");
  $('#announcement-snippet-form').on('submit', (event) => {
    event.preventDefault();

    var hoster_id = $('select#hoster_id').val();
    var title = $('input#title').val();
    var body = $('textarea#body').val();

    $.ajax({
      method: "POST",
      url: "/accounts/announcements",
      data: {
        snippet: true,
        hoster_id: hoster_id,
        title: title,
        body: body
      },
      dataType: 'json',
      success: (response) => {
        show_layout_modal("Your snippet announcement was successfully saved.");
        console.log("Snippet announcement save success");
      },
      error: (resp, textStatus, xhr) => {
        var respBody = resp.responseJSON;
        console.log(`Snippet announcement save failure - code=${resp.status}`);
        if (respBody !== undefined) {
          if ($('#announcement-snippet-form').closest('#layout-modal').length > 0) {
            $('#announcement-snippet-form div#error-messages').html(respBody.error);
            $('#announcement-snippet-form div#error-messages').removeClass("d-none");
          } else {
            show_layout_modal(`Failed to save announcement: ${respBody.error}.`);
          }
        } else {
          show_layout_modal(`Server error: ${resp.status}`);
        }
      }
    });
  });
}
